/* eslint-disable no-param-reassign */
import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

export enum SnackbarStatus {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info'
}

export interface Snackbar {
  title?: string;
  message: string | null;
  show: boolean;
  redirectAction?: { title: string; url: string; newTab?: boolean } | null;
  status: SnackbarStatus | null;
  useNewSnackbar?: boolean;
}

const snackbar = createSlice({
  name: 'snackbar',
  initialState: {
    message: null,
    show: false,
    status: null,
    redirectAction: null,
    useNewSnackbar: false
  },
  reducers: {
    setSnackbar: (state: Snackbar, { payload }: PayloadAction<Snackbar>) => {
      state.title = payload.title;
      state.message = payload.message;
      state.show = payload.show;
      state.status = payload.status;
      state.redirectAction = payload.redirectAction;
      state.useNewSnackbar = payload.useNewSnackbar;
    },
    clearSnackbar: (state: Snackbar) => {
      state.message = null;
      state.show = false;
    }
  }
});

export const snackbarSelector = createSelector(
  (state: RootState) => state,
  state => state.snackbar
);

export const { clearSnackbar, setSnackbar } = snackbar.actions;

export default snackbar.reducer;
